export default "__VITE_ASSET__pq_1vtGE__"